import NamedDto from 'modules/base/dto/NamedDto';
import { normalizeScenarioAttributes } from '../component/WhatIfScenarioUtil';

export class WhatIfScenarioTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {NamedDto} */
		this.whatIf = null;
		/** @type {NamedDto} */
		this.creator = null;
		/** @type {Date} */
		this.created = null;
		/** @type {Object[]} */
		this.attributes = null;
	}

	/**
	 * @typedef {Object} _WhatIfScenarioTableDtoProps
	 * @property {NamedDto} whatIf
	 * @property {NamedDto} creator
	 * @property {Date} created
	 * @property {Object[]|Object} attributes
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _WhatIfScenarioTableDtoProps} WhatIfScenarioTableDtoProps
	 */
	/**
	 *
	 * @param {WhatIfScenarioTableDtoProps} props
	 * @returns {WhatIfScenarioTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.whatIf = props.whatIf != null ? new NamedDto().setup(props.whatIf) : null;
		this.creator = props.creator != null ? new NamedDto().setup(props.creator) : null;
		this.created = props.created != null ? new Date(props.created) : null;
		this.attributes = normalizeScenarioAttributes(props.attributes);
		return this;
	}
}

export default WhatIfScenarioTableDto;
